import { render } from "./UpdatePasswordPage.vue?vue&type=template&id=d7897ab4"
import script from "./UpdatePasswordPage.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordPage.vue?vue&type=script&lang=js"

import "./UpdatePasswordPage.vue?vue&type=style&index=0&id=d7897ab4&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__